import { isTauri } from "@/hooks/usePlatform";

export type RuntimeEnvVars = Record<string, string>;

export async function getAnthropicApiKeyFromKeychain(): Promise<string | null> {
  if (!isTauri()) return null;

  try {
    const { invoke } = await import("@tauri-apps/api/core");
    const value = await invoke<string | null>("get_secret", { key: "anthropic_api_key" });
    if (typeof value !== "string") return null;
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : null;
  } catch {
    return null;
  }
}

export async function injectInheritedAiEnvVars(envVars: RuntimeEnvVars): Promise<void> {
  if (envVars["ANTHROPIC_API_KEY"]) return;

  const anthropicKey = await getAnthropicApiKeyFromKeychain();
  if (anthropicKey) {
    envVars["ANTHROPIC_API_KEY"] = anthropicKey;
  }
}
